const _ACTION_PREFIX = '[frontend/auth]';

export const AUTH_SUCCESSFUL = `${_ACTION_PREFIX} AUTH_SUCCESSFUL`;
export const AUTH_FAILED = `${_ACTION_PREFIX} AUTH_FAILED`;

export const successful = () => ({
  type: AUTH_SUCCESSFUL,
});

export const failed = () => ({
  type: AUTH_FAILED,
});
